<template>
    <div class="notificacion">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="90%" scrollable>
                    <v-card>
                        <template>
                            <v-toolbar color="primary" dark flat>
                                <v-toolbar-title>
                                    <v-icon medium>fa fa-cog</v-icon>
                                    Lista de notificaciones
                                </v-toolbar-title>

                                <v-divider class="mx-2" inset vertical></v-divider>

                                <v-flex sm3 class="pa-0" style="max-width: 190px">
                                    <v-overflow-btn
                                        v-model="notificacionEstado"
                                        label="Notificación"
                                        :items="[
                                            { text: 'Todas', value: '1' },
                                            { text: 'Habilitadas', value: '2' },
                                            { text: 'Deshabilitadas', value: '3' }
                                        ]"
                                        hide-details
                                        class="pa-0"
                                        @change="loadNotificacion()"
                                    >
                                        <template v-slot:item="data">
                                            <v-list-tile-content>
                                                <v-card-text class="pa-0 ">
                                                    <v-icon
                                                        :color="getIconColor(data)"
                                                        class="pr-3"
                                                        v-if="data.item.value !== '1'"
                                                        >fa-list
                                                    </v-icon>
                                                    {{ data.item.text }}
                                                </v-card-text>
                                            </v-list-tile-content>
                                        </template>
                                    </v-overflow-btn>
                                </v-flex>

                                <v-divider class="px-1" inset vertical></v-divider>

                                <v-spacer></v-spacer>

                                <v-toolbar-items>
                                    <v-btn icon @click="toogleSearch()">
                                        <v-icon medium>fa-search</v-icon>
                                    </v-btn>

                                    <v-expand-x-transition>
                                        <v-text-field
                                            hide-details
                                            solo
                                            v-show="searchShow"
                                            v-model="filter.search"
                                            placeholder="Filtrar"
                                            class="hidden-sm-and-down pt-2"
                                        >
                                        </v-text-field>
                                    </v-expand-x-transition>

                                    <v-menu
                                        v-model="filtroMenu"
                                        origin="center center"
                                        class="elelvation-1"
                                        transition="slide-y-transition"
                                        top
                                        left
                                        min-width="500"
                                        max-height="500"
                                        :close-on-content-click="false"
                                    >
                                        <template v-slot:activator="{ on: menu }">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on: tooltip }">
                                                    <v-btn icon flat>
                                                        <v-badge color="orange" overlap>
                                                            <span slot="badge" v-if="activeFilters > 0">{{
                                                                activeFilters
                                                            }}</span>
                                                            <v-icon medium v-on="{ ...tooltip, ...menu }"
                                                                >fa-filter</v-icon
                                                            >
                                                        </v-badge>
                                                    </v-btn>
                                                </template>
                                                <span>Filtro Personalizado</span>
                                            </v-tooltip>
                                        </template>
                                        <custom-filter-adm-notificacion
                                            v-if="filtroMenu"
                                            :internal-state="filterInternalState"
                                            @applyFilter="applyFilter"
                                        ></custom-filter-adm-notificacion>
                                    </v-menu>

                                    <v-divider class="pa-2"></v-divider>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card-text class="pa-0">
                                <v-data-table
                                    :headers="headers"
                                    :loading="loading"
                                    :pagination.sync="pagination"
                                    :rows-per-page-items="pagination.rowsPerPageItems"
                                    :total-items="totalItems"
                                    :items="NOTIFICACIONES"
                                    class="elevation-1"
                                    item-key="id"
                                >
                                    <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>{{ props.item.user ? props.item.user.username : "-" }}</td>
                                            <td>
                                                <v-chip
                                                    small
                                                    dark
                                                    label
                                                    :color="getChipLabelColor(props.item)"
                                                    style="font-size: 12px"
                                                >
                                                    {{ props.item.status_lectura ? props.item.status_lectura : "-" }}
                                                </v-chip>
                                            </td>
                                            <td>
                                                {{
                                                    props.item.notificationGestor
                                                        ? props.item.notificationGestor.nombre
                                                        : "-"
                                                }}
                                                <v-icon :disabled="menuLocked" @click="viewDetails(props)"
                                                    >fa-question</v-icon
                                                >
                                            </td>
                                            <td>
                                                <v-chip
                                                    small
                                                    dark
                                                    :color="getChipColor(props.item)"
                                                    style="font-size: 12px"
                                                >
                                                    {{
                                                        props.item.status_description
                                                            ? props.item.status_description
                                                            : "-"
                                                    }}
                                                </v-chip>
                                            </td>
                                            <td class="pl-0">
                                                <v-layout class="justify-end">
                                                    <div style="width: 156px">
                                                        <v-fade-transition>
                                                            <div :key="props.item.id">
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn
                                                                            flat
                                                                            icon
                                                                            :color="
                                                                                props.item.leida === 2
                                                                                    ? 'success'
                                                                                    : 'red'
                                                                            "
                                                                            :loading="loadingStatusLeida"
                                                                            :disabled="loading || menuLocked"
                                                                            @click="modificarLectura(props.item)"
                                                                        >
                                                                            <v-icon medium v-on="on">{{
                                                                                props.item.leida === 2
                                                                                    ? "fa-thumbs-up"
                                                                                    : "fa-thumbs-down"
                                                                            }}</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>{{
                                                                        props.item.leida === 2
                                                                            ? "Modificar a Leida"
                                                                            : "Modificar a Sin leer"
                                                                    }}</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn
                                                                            flat
                                                                            icon
                                                                            color="red"
                                                                            :disabled="loading || menuLocked"
                                                                            @click="deleteItem(props)"
                                                                        >
                                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Deshabilitar Notificación</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn
                                                                            flat
                                                                            icon
                                                                            color="grey"
                                                                            :loading="loadingHistory"
                                                                            :disabled="loading || menuLocked"
                                                                            @click="loadHistory(props.item)"
                                                                        >
                                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Ver historial</span>
                                                                </v-tooltip>
                                                            </div>
                                                        </v-fade-transition>
                                                    </div>
                                                </v-layout>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:expand="props">
                                        <v-card>
                                            <v-card-text
                                                v-if="rowExpandedOption === 1"
                                                class="py-0 py-2 pl-0 text-xs-center"
                                                style="height: 44px"
                                            >
                                                <strong>Descripción. </strong>
                                                {{
                                                    props.item.notificationGestor
                                                        ? props.item.notificationGestor.descripcion
                                                        : "-"
                                                }}
                                            </v-card-text>
                                            <v-card-text v-else class="py-0 pl-0 text-xs-right">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                            <v-icon v-on="on">fa-close</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Cancelar acción</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            icon
                                                            flat
                                                            color="green"
                                                            @click="deleteItemConfirm(props)"
                                                        >
                                                            <v-icon v-on="on">fa-check</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Confirmar acción</span>
                                                </v-tooltip>
                                            </v-card-text>
                                        </v-card>
                                    </template>
                                    <template slot="no-data">
                                        <div style="text-align: center">
                                            No existen notificaciones registradas en el sistema.
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </template>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Notificación'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const CustomFilterAdmNotificacion = () =>
    import(/* webpackChunkName: "filtro-notificacion" */ "@/components/widgets/custom-filter-notificacion/custom-filter-adm-notificacion")
const TimeLine = () =>
    import(/* webpackChunkName: "historiales-time-line" */ "@/components/widgets/records-time-line/time-line")
export default {
    components: { CustomFilterAdmNotificacion, TimeLine },
    data: () => ({
        searchShow: false,
        loading: false,
        headers: [
            { text: "Usuario", value: "user_id" },
            { text: "Lectura", value: "leida" },
            { text: "Nombre", value: "notification_gestor_id" },
            { text: "Estado", value: "status_description" },
            { sortable: false }
        ],
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteConfirmId: "",

        menuLocked: false,

        //estado de los tipo de notificacions a cargar del back
        notificacionEstado: "2",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //modificar el estado de lectura
        loadingStatusLeida: false,

        //opcion para mostrar cuando se despliega la fila expand
        rowExpandedOption: null,

        //filtro personalizado
        filtroMenu: false,
        customFilter: null,
        activeFilters: 0,

        //estado interno del filtro
        filterInternalState: null,

        //para saber si se cargo el filtro
        filterLoaded: false
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_NOTIFICACIONES", {
                    filter: this.filter.search,
                    notificacionEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        modificarLectura(item) {
            this.loadingStatusLeida = true
            this.$store.dispatch("UPDATE_NOTIFICACION", item).then((this.loadingStatusLeida = false))
        },

        deleteItem(props) {
            this.rowExpandedOption = null
            this.menuLocked = true
            this.deleteConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_NOTIFICACION", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteConfirmId = ""
            props.expanded = !props.expanded
        },

        loadNotificacion() {
            this.loadData(this.notificacionEstado)
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Notificacion")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.notificacionEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getChipLabelColor(item) {
            switch (item.leida) {
                case 2:
                    return "red lighten-1"
                case 1:
                    return "success lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        },

        cancelForm() {
            this.$emit("formCanceled", { filterLoaded: this.filterLoaded })
        },

        closeForm() {
            this.showTipoNotificacionForm = false
            this.editItem = null
        },

        viewDetails(props) {
            if (!props.expanded) {
                this.rowExpandedOption = 1
                props.expanded = true
            } else {
                this.rowExpandedOption = null
                props.expanded = false
            }
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.filtroMenu = false
                this.notificacionEstado = "6"
                this.customFilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.notificacionEstado, this.customFilter)
            } else {
                this.notificacionEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.notificacionEstado, this.customfilter)
                this.filtroMenu = false
            }
            this.filterInternalState = { inputs: value.inputs, selectedCampos: value.selectedCampos }
        }
    },

    computed: {
        ...mapGetters(["NOTIFICACIONES"]),

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        pagination: {
            get: function() {
                return this.$store.getters.NOTIFICACIONES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_NOTIFICACIONES_PAG", value)
            }
        },

        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.notificacionEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        },

        //salvar si se cargo el filtro
        filtroMenu: function() {
            if (this.filtroMenu && !this.filterLoaded) {
                this.filterLoaded = true
            }
        }
    }
}
</script>
